<div >
  <mat-form-field style="width: 100%;">
    <mat-label>{{placeholder}}</mat-label>
      <input matInput type="text"
      (keyup)="userInputDetected()"
      [(ngModel)]="selectedValue">
  </mat-form-field>
</div>
